.button {
    align-items: center;
    border: none;
    border-radius: var(--button-border-radius);
    cursor: pointer;
    display: flex;
    gap: var(--button-gap);
    transition: var(--button-transition);
    width: 100%;

    &:disabled {
        cursor: not-allowed;
        opacity: var(--button-disabled-opacity);
    }
}

.icon {
    align-items: center;
    display: inline-flex;
    flex-shrink: 0;
    height: var(--button-icon-size);
    justify-content: center;
    width: var(--button-icon-size);
}

.md {
    padding: var(--button-md-padding);
}

.sm {
    padding: var(--button-sm-padding);
}

.filled {
    background-color: var(--button-filled-background-color);
    box-shadow: var(--button-filled-box-shadow);
    color: var(--button-filled-color);

    &:hover:not(:disabled) {
        background-color: var(--button-filled-hover-background-color);
        box-shadow: var(--button-filled-hover-box-shadow);
    }
}

.outlined {
    background-color: var(--button-outlined-background-color);
    border: var(--button-outlined-border);
    color: var(--button-outlined-color);

    &:hover:not(:disabled) {
        background-color: var(--button-outlined-hover-background-color);
    }
}

.text {
    background-color: var(--button-text-background-color);
    color: var(--button-text-color);

    &:hover:not(:disabled) {
        background-color: var(--button-text-hover-background-color);
    }
}

.danger {
    background-color: var(--button-danger-background-color);
    box-shadow: var(--button-danger-box-shadow);
    color: var(--button-danger-color);

    &:hover:not(:disabled) {
        background-color: var(--button-danger-hover-background-color);
    }
}

.pill {
    border-radius: var(--button-pill-border-radius);

    &.md {
        padding: var(--button-pill-md-padding);
    }

    &.sm {
        padding: var(--button-pill-sm-padding);
    }
}
